import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest, postRequest } from '../config/axios-config';

const signIn = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.signIn,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const login = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.login,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const checkVerificationLink = async (userId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.checkVerificationLink +
          '/' +
          userId +
          '/' +
          token
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const resendVerificationLink = async (userId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.resendVerificationLink +
          '/' +
          userId +
          '/' +
          token
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const sendPasswordResetLink = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.sendPasswordResetLink,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const resetPassword = async (userId, token, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.resetPassword +
          '/' +
          userId +
          '/' +
          token,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const checkPasswordReset = async (userId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.checkPasswordReset +
          '/' +
          userId +
          '/' +
          token
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const resendResetPasswordLink = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.sendPasswordResetLink,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const sendOtpMasterLogin = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.masterLogin,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const verifyOtpMasterLogin = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.verifyMasterLoginOtp,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const teamSignIn = async (body, teamMemberId, code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.teamSignIn +
          '/' +
          teamMemberId +
          '/' +
          code,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const verifyRegisterOTP = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.verifyRegisterOTP,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
const verifyRegisterMasterLogin = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.verifyRegisterMasterLogin,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export {
  signIn,
  login,
  checkVerificationLink,
  resendVerificationLink,
  sendPasswordResetLink,
  resetPassword,
  checkPasswordReset,
  resendResetPasswordLink,
  sendOtpMasterLogin,
  verifyOtpMasterLogin,
  teamSignIn,
  verifyRegisterMasterLogin,
  verifyRegisterOTP,
};
